export function isModalEditable(field, data) {
  return data.resource_type === "sale" && field.name === "closed_date"
}

export function openEditModal(_field, data, editType) {
  window.Turbo.visit(
    `/markets/global/sales/view/${data.id}/identity/edit?edit_type=${editType}`,
    { frame: "modal" }
  )
}
